import React, { FC, useEffect, useState } from 'react';
import { Button, Checkbox, Form, Grid, Modal, Table } from '../../kit';
import { ApiProfile } from '../../api/auth';
import { money } from '../../lib/util';
import { request } from '../../api';

export const needSubscription = (profile: ApiProfile): void => {
    dispatchEvent(new CustomEvent('need-sub', { detail: { profile }}));
}

const NeedSubscriptionModal: FC = (): JSX.Element => {
    const [ errors, setErrors ] = useState<any>({});
    const [ isLoading, setIsLoading ] = useState<boolean>(false);
    const [ open, setOpen ] = useState<boolean>(false);
    const [ profile, setProfile ] = useState<any>();

    useEffect(() => {
        const handleOpen = ({ detail }: any): void => {
            setOpen(true);
            setProfile(detail.profile);
        }

        window.addEventListener('need-sub', handleOpen);
        return () => window.removeEventListener('need-sub', handleOpen);
    }, []);

    const handleInput = ({ name, value }: any): void => {
        setProfile({
            ...profile,
            [name]: value,
        });
    }

    const save = (): void => {
        setErrors({});
        setIsLoading(true);
        request.post(`auth/upgrade`, profile).then(({ data }) => {
            setIsLoading(false);
            window.location.href = data.paymentUrl;
        }).catch((err) => {
            setErrors(err.response.data.errors);
            setIsLoading(false);
        });
    }

    return (
        <Modal
            header="Abonnement wijzigen"
            onClose={() => setOpen(false)}
            open={open}
            style={{ width: 850 }}
            footer={(
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        color="transparent"
                        label="Annuleren"
                        onClick={() => setOpen(false)}
                    />
                    <Button
                        color="primary"
                        label="Bestellen"
                        onClick={save}
                    />
                </div>
            )}  
        >
            <p>
                Vul hieronder je gegevens aan en kies het abonnement waar je gebruik van wilt maken.
            </p>

            <Form onSubmit={() => false}>
                <Grid.Row>
                    <Grid.Column lg={6}>
                        <Form.Input
                            label="Bedrijfsnaam"
                            name="organisation"
                            onChange={handleInput}
                            value={profile?.organisation}
                        />
                        <Grid.Row style={{ marginBottom: 16 }}>
                            <Grid.Column lg={4}>
                                <Form.Input
                                    error={errors.first_name}
                                    label="Voornaam"
                                    name="first_name"
                                    onChange={handleInput}
                                    required
                                    value={profile?.first_name}
                                />
                            </Grid.Column>
                            <Grid.Column lg={3} style={{ padding: 0 }}>
                                <Form.Input
                                    label="Tussenvoegsel"
                                    name="affix"
                                    onChange={handleInput}
                                    value={profile?.affix}
                                />
                            </Grid.Column>
                            <Grid.Column lg={5}>
                                <Form.Input
                                    error={errors.last_name}
                                    label="Achternaam"
                                    name="last_name"
                                    onChange={handleInput}
                                    required
                                    value={profile?.last_name}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Form.Input
                            error={errors.email_address}
                            label="E-mailadres"
                            name="email_address"
                            onChange={handleInput}
                            required
                            type="email"
                            value={profile?.email_address}
                        />
                        <Form.Input
                            error={errors.address}
                            label="Adres"
                            name="address"
                            onChange={handleInput}
                            required
                            value={profile?.address}
                        />
                        <Grid.Row style={{ marginBottom: 16 }}>
                            <Grid.Column lg={4} style={{ paddingRight: 0 }}>
                                <Form.Input
                                    error={errors.zipcode}
                                    label="Postcode"
                                    name="zipcode"
                                    onChange={handleInput}
                                    required
                                    value={profile?.zipcode}
                                />
                            </Grid.Column>
                            <Grid.Column lg={8}>
                                <Form.Input
                                    error={errors.city}
                                    label="Plaats"
                                    name="city"
                                    onChange={handleInput}
                                    required
                                    value={profile?.city}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid.Column>
                    <Grid.Column lg={6}>
                        <Form.Group>
                            <label>Heb je de offline SPAT Academy afgerond?</label>
                            <div style={{ display: 'flex' }}>
                                <Checkbox
                                    radio
                                    label="Ja"
                                    onChange={() => handleInput({ name: 'academy_offline', value: true })}
                                    checked={profile?.academy_offline === true}
                                />
                                <Checkbox
                                    radio
                                    label="Nee"
                                    onChange={() => handleInput({ name: 'academy_offline', value: false })}
                                    checked={profile?.academy_offline === false}
                                />
                            </div>
                        </Form.Group>
                        {profile?.academy_offline === false && (<>
                            <Form.Group>
                                <label>Heb je de online SPAT Academy afgerond?</label>
                                <div style={{ display: 'flex' }}>
                                    <Checkbox
                                        radio
                                        label="Ja"
                                        onChange={() => handleInput({ name: 'academy_online', value: true })}
                                        checked={profile?.academy_online === true}
                                    />
                                    <Checkbox
                                        radio
                                        label="Nee"
                                        onChange={() => handleInput({ name: 'academy_online', value: false })}
                                        checked={profile?.academy_online === false}
                                    />
                                </div>
                            </Form.Group>
                            {profile?.academy_online === false && (<>
                                <Form.Group>
                                    <label>Heb je het boek Intelligent Bewegen gelezen?</label>
                                    <div style={{ display: 'flex' }}>
                                        <Checkbox
                                            radio
                                            label="Ja"
                                            onChange={() => handleInput({ name: 'read_book', value: true })}
                                            checked={profile?.read_book === true}
                                        />
                                        <Checkbox
                                            radio
                                            label="Nee"
                                            onChange={() => handleInput({ name: 'read_book', value: false })}
                                            checked={profile?.read_book === false}
                                        />
                                    </div>
                                </Form.Group>
                                {profile?.read_book === false && (
                                    <Form.Group>
                                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <img src="https://www.spatverandert.nl/wp-content/uploads/2018/10/3D-boek-copy.png" alt="" style={{ width: 60, marginRight: 16 }} />
                                            <p style={{ flex: 1 }}><b>Ja!</b> Ik bestel hierbij graag het boek "Intelligent Bewegen" voor € 18,35 (excl. btw).</p>
                                        </div>
                                    </Form.Group>
                                )}
                            </>)}
                        </>)}
                        <Form.Dropdown
                            label="Betaling"
                            required
                            options={[{
                                text: 'Maandabonnement (€ 25,- / maand)',
                                value: 'monthly',
                            }, {
                                text: 'Jaarabonnement (€ 250,- / jaar)',
                                value: 'yearly',
                            }]}
                            name="payment"
                            onChange={handleInput}
                            value={profile?.payment || 'monthly'}
                        />
                        <Table>
                            <tbody>
                                <Table.Row>
                                    <Table.Cell>
                                        {profile?.payment === 'yearly' ? 'Jaarabonnement' : 'Maandabonnement'}
                                    </Table.Cell>
                                    <Table.Cell align="right">
                                        {money(profile?.payment === 'yearly' ? 250 : 25)}
                                    </Table.Cell>
                                </Table.Row>
                                {profile?.academy_online === false && profile?.read_book === false && (
                                    <Table.Row>
                                        <Table.Cell>
                                            Intelligent Bewegen
                                        </Table.Cell>
                                        <Table.Cell align="right">
                                            {money(18.35)}
                                        </Table.Cell>
                                    </Table.Row>
                                )}
                                <Table.Row>
                                    <Table.Cell>
                                        BTW
                                    </Table.Cell>
                                    <Table.Cell align="right">
                                        {money(
                                            ((profile?.payment === 'yearly' ? 250 : 25) * .21) +
                                            (profile?.academy_online === false && profile?.read_book === false
                                                ? (18.35 * .09)
                                                : 0)
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        <b>Totaal</b>
                                    </Table.Cell>
                                    <Table.Cell align="right">
                                        <b>{money(
                                            ((profile?.payment === 'yearly' ? 250 : 25) * 1.21) +
                                            (profile?.academy_online === false && profile?.read_book === false
                                                ? (18.35 * 1.09)
                                                : 0)
                                        )}</b>
                                    </Table.Cell>
                                </Table.Row>
                            </tbody>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Form>
        </Modal>
    );
}

export default NeedSubscriptionModal;
